class QuickviewTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.closest("button");

    if (!this.button) return;

    this.button.addEventListener("mouseenter", () => {
      this._getData();
    });

    this.button.addEventListener("click", () => {
      console.log(`Open quickshop`, this.url);
      const detail = { target: "quickview-modal", html: this._getData() };

      if (this.setItemId) {
        detail.customData = this.setItemId;
      }

      this.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail,
        }),
      );
    });
  }

  disconnectedCallback() {}

  _getData() {
    const url = new URL(`${window.location.origin}${this.url}`);
    url.searchParams.set("section_id", this.sectionId);

    this.lastUrl = url.toString();

    if (url === this.lastUrl) {
      if (this._data) return Promise.resolve(this._parseData(this._data));
      if (this.loadingData) return this.loadingData;
    }

    this.loadingData = fetch(url)
      .then((res) => res.text())
      .then((data) => {
        this._data = data;

        return this._parseData(data);
      });

    return this.loadingData;
  }

  _parseData(data) {
    const section = new DOMParser().parseFromString(data, "text/html");
    const targetEl = document
      .createRange()
      .createContextualFragment(section.querySelector("body").innerHTML);

    if (this.quantity) {
      const quantityInput =
        targetEl.children[0].querySelector('[name="quantity"]');
      quantityInput.value = this.quantity;
    }

    return targetEl;
  }

  get url() {
    return this.getAttribute("url");
  }

  get sectionId() {
    return this.getAttribute("section-id") || "quickview";
  }

  get setItemId() {
    return this.getAttribute("set-item-id") || null;
  }

  get quantity() {
    return this.getAttribute("quantity") || null;
  }
}

if (!customElements.get("quickview-trigger")) {
  customElements.define("quickview-trigger", QuickviewTrigger);
}
